import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionCtl } from 'lib-klab-core';
import { CUSTOMER_ACCESS_DENIED_URL, hasCustomerPortalAccess } from '../../modules/home/customer-iam-access.util';

export const authGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const sessionCtl = inject(SessionCtl);

  const isLoggedIn = sessionCtl.loggedInCheckSync();
  if (isLoggedIn) return hasCustomerPortalAccess(sessionCtl.menu) ? true : router.parseUrl(CUSTOMER_ACCESS_DENIED_URL);

  return router.parseUrl(`/login?redirect=${encodeURIComponent(state.url)}`);
};
